export const PTS_ADMIN_SECTIONS = {
    gmsUsers: "GMS Users",
    managePrograms: "Manage Programs"
};